import { classNames } from '@shopify/css-utilities'
import { Link } from '@shopify/hydrogen'
import { kebabCase } from 'lodash'
import { useContext } from 'react'
import styles from '../../assets/scss/components/desktop-menu.module.scss'
import { EnhancedMenu, EnhancedMenuItem } from '../../lib/menus'
import { HeaderContext } from '../header/header-provider.client'
import { useI18n } from '../i18n.client'

export const AdditionalMenu: React.FC<{ menu: EnhancedMenu }> = ({ menu }) => {
  const [i18n] = useI18n()
  const { activeDesktopParentMenuIndex } = useContext(HeaderContext)

  if (activeDesktopParentMenuIndex > 0) {
    return null
  }

  return (
    <div className={styles.additionalMenu}>
      <div className={styles.title}>{i18n.translate(kebabCase(menu.title))}</div>
      {menu.items.map((item, index) => (
        <MenuItem index={index} item={item} key={item.id} />
      ))}
    </div>
  )
}

const MenuItem: React.FC<{ index: number; item: EnhancedMenuItem }> = ({ item }) => {
  const [i18n] = useI18n()
  const { setActiveAdditionalMenuItem, setIsMainNavigationOpen } = useContext(HeaderContext)

  const handleClick = () => {
    setIsMainNavigationOpen(false)
  }

  return (
    <Link
      className={classNames(styles.menuItem)}
      onClick={handleClick}
      onMouseOut={() => setActiveAdditionalMenuItem(undefined)}
      onMouseOver={() => setActiveAdditionalMenuItem(item)}
      to={item.to}>
      {item.translationId ? i18n.translate(item.translationId) : item.title}
    </Link>
  )
}
